import { render, staticRenderFns } from "./VerificationInput.vue?vue&type=template&id=330c4c01"
import script from "./VerificationInput.vue?vue&type=script&lang=js"
export * from "./VerificationInput.vue?vue&type=script&lang=js"
import style0 from "./VerificationInput.vue?vue&type=style&index=0&id=330c4c01&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports